import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useMemo } from 'react'

import {
  type CommandPaletteSection,
  useRegisterPaletteSection
} from '@/domains/command-palette'

export const THEME_SECTION_ID = 'theme'

/** one-shot Toggle Theme action row. flips light↔dark. label + icon
 * describe the destination (in dark mode the row reads "Light Mode"
 * because that's where clicking takes you). drilling into a theme
 * picker is overkill with only two options.
 */
export function useRegisterThemeSection() {
  const { setTheme, resolvedTheme } = useTheme()
  const isDark = resolvedTheme === 'dark'

  const section = useMemo<CommandPaletteSection>(
    () => ({
      id: THEME_SECTION_ID,
      title: isDark ? 'Light Mode' : 'Dark Mode',
      icon: isDark ? Sun : Moon,
      group: 'Actions',
      onSelect: () => setTheme(isDark ? 'light' : 'dark')
    }),
    [isDark, setTheme]
  )
  useRegisterPaletteSection(section)
}
